<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card :loading="loading">
      <v-card-title class="headline"
        >Email Bid #{{ this.item.id }}</v-card-title
      >
      <v-card-text>
        <v-container>
          <alert-message />
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="form.to"
                label="To"
                :error-messages="
                  [].concat(fieldErrors('form.to'), serverSideErrors('To'))
                "
                @blur="$v.form.to.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="form.cc"
                label="Cc"
                :error-messages="
                  [].concat(fieldErrors('form.cc'), serverSideErrors('Cc'))
                "
                @blur="$v.form.cc.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="form.subject"
                label="Subject"
                :error-messages="
                  [].concat(
                    fieldErrors('form.subject'),
                    serverSideErrors('Subject')
                  )
                "
                @blur="$v.form.subject.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <tiptap-vuetify v-model="form.content" :extensions="extensions" />
            </v-col>

            <v-col>
              <v-btn @click="preview()" v-show="false" x-small>Preview Bid</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div
          style="
            visibility: hidden;
            position: absolute;
            left: 0;
            top: 0;
            z-index: -1000;
          "
        >
          <PdfView :item="item" @onImg="setAttachment($event)" />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">Cancel</v-btn>
        <v-btn class="info" text @click="submit" :loading="loading"
          >Send Bid
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage.vue";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "src/mixins/formatterMixin";
import { required } from "vuelidate/lib/validators";
import PdfView from "./_PdfView";
import { init, send } from "emailjs-com";
init("user_D60wetKQa2YZrQ4uRq7Fl");

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  mixins: [validationMixin, formatterMixin],
  components: { AlertMessage, TiptapVuetify, PdfView },
  props: {
    item: Object,
    show: [Boolean, String],
  },
  validations: {
    form: {
      to: {},
      cc: {},
      subject: { required },
      content: { required },
    },
  },
  validationMessages: {
    form: {
      to: {
        required,
      },
      cc: {},
      subject: { required: "Required" },
      content: { required: "Required" },
    },
  },
  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      form: {
        to: "",
        cc: "",
        subject: "",
        content: "",
        files: [],
      },
      dialog: false,
      loading: false,
      img: "",
    };
  },
  computed: {
    ...mapState({
      client: (state) => state.client.single,
      company: (state) => state.account.data.account,
      alert: (state) => state.alert,
      quote: (state) => state.quote,
    }),

    quoteBlob() {
      return this.img;
    },
  },
  watch: {
    async show(n, o) {
      this.$store.dispatch("alert/clear");
      if (n && !o) {
        this.dialog = true;
      }
    },
    async dialog(n) {
      if (n) {
        this.loading = true;
        await this.clientGetById(this.item.clientId);
        this.loading = false;
      } else {
        this.closeDelete();
      }
    },

    item(n) {
      if (n) {
        this.form.to = n.email;
        this.form.content = this.formatContent();
        this.form.subject = `Bid #${this.item.id} from ${this.company.companyName} is now ready!`;
      }
    },

    client(n) {
      if (n) {
        this.form.to = n.email;
        this.form.content = this.formatContent();
        this.form.subject = `Bid #${this.item.id} from ${this.company.companyName} is now ready!`;
      }
    },

    quoteBlob() {
      this.form.content = this.formatContent();
    },
  },
  beforeDestroy() {
    this.img = "";
  },
  methods: {
    ...mapActions({
      clientGetById: "client/getById",
      quoteSendEmail: "quote/sendEmail",
      quoteUpdate: "quote/update",
    }),

    sendEmail() {
      //template_uljqw3j
      let params = {
        subject: this.form.subject,
        message: this.form.content,
        to_email: this.form.to,
      };
      return send(`service_8yp8ffq`, `template_uljqw3j`, params);
    },

    setAttachment(value) {
      this.img = value.src;
    },

    serverSideErrors() {
      return [];
      // return UTIL.gv(this.userGroup.errors, field, []);
    },

    formatContent() {
      let html = `
        <p>Please click the link below to view your bid online, or download the attached PDF.</p>
        <p><a href="${this.quoteBlob}" target="_blank">Click here to view your bid</a></p>
        <p>If you have any questions, comments or concerns, please contact us at ${this.company.companyName}</p>
        <br />
        <p>
          Best Regards,
          ${this.company.companyName}<br />
          ${this.company.accountAddress}<br /> 
          ${this.company.accountCity}, ${this.company.accountState}, ${this.company.accountZipcode}<br />
          Office: ${this.company.phoneNumber}<br />
          Email: ${this.company.email}<br />
        </p>      
        <br />
      `;
      return html;
    },

    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },

    preview() {
      var w = window.open("", this.item.id, "", false);
      w.document.write(`<img src="${this.quoteBlob}" />`);
    },
    async submit() {
      this.loading = true;

      let cc = [];
      if (this.form.cc) {
        cc = [].concat(this.form.cc);
      }

      let to = [];
      if (this.form.to) {
        to = [].concat(this.form.to);
      }

      let files = [];
      if (this.quoteBlob) {
        files = [].concat(this.quoteBlob);
      }

      let payload = {
        ...this.form,
        id: this.item.id,
        to: to,
        cc: cc,
        files: files,
      };
      // await this.sendEmail();
      await this.quoteSendEmail(payload);
      this.loading = false;
      if (!this.quote.status.error) {
        /**
         * Change status to `sent` after email sent
         */
        let quote = {          
          ...this.item,
          status: "sent",
        };

        let { lineItems } = this.item;

        let cleanedLineItems = lineItems.map((item) => {
          delete item.id;
          return {
            ...item
          }
        });

        await this.quoteUpdate({
          id: this.item.id,
          quote,
          lineItems: cleanedLineItems
        });

        this.closeDelete();
        this.$emit("onSucceded");
      }
    },
  },
};
</script>